const injectClipsPropsToList = (list, clipProps) =>
  list?.map(el => ({ ...el, props: { ...(el?.props || {}), ...clipProps } }));

export default injectClipsPropsToList;
